import { Row, Col } from "antd";
import Container from "../../common/Container";

import {
  FooterSection,
  Title,
  LogoContainer,
  Large,
  Language,
} from "./styles";

const Footer = () => {
  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between" gutter={[24, 0]}>
            <Col lg={8} md={8} sm={8} xs={24}>
              <LogoContainer aria-label="homepage">
                <img src="img/logo/logo-full.png" alt="Buy Reddit Accounts" width="200px" height="64px" style={{ objectFit: 'contain' }} />
              </LogoContainer>
            </Col>
            <Col lg={8} md={8} sm={8} xs={24}>
              <Language>Contact Us</Language>
              <Large as="a" href="https://www.buyupvotes.io/contact-us/" target="_blank" rel="noopener noreferrer">
                Contact Form
              </Large>
              <Large as="a" href="https://t.me/buyupvotessupport" target="_blank" rel="noopener noreferrer">
                Telegram
              </Large>
            </Col>
            <Col lg={8} md={8} sm={8} xs={24}>
              <Title>Legal</Title>
              <Large as="a" href="https://www.buyupvotes.io/terms-and-conditions/" target="_blank" rel="noopener noreferrer">
                Terms and Conditions
              </Large>
              <Large as="a" href="https://www.buyupvotes.io/terms-and-conditions/" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </Large>
            </Col>
          </Row>
        </Container>
      </FooterSection>
    </>
  );
};

export default Footer;
